import { connect } from "react-redux";

import { FullFormState } from "../../../../Engine/Core/Store/FullFormState";
import { CaptionsViewMode } from "../../../Internals/ViewModeSelector/ViewModes";

import { Long } from "./Long";

const mapStateToProps = (state: FullFormState) => ({
    visible: state.viewModes.captions === CaptionsViewMode.Long,
});

export const LongContainer = connect(mapStateToProps)(Long);
